import { Page, FormView } from 'web-mojo';

class GroupSettingsFormView extends FormView {
    constructor(options = {}) {
        super({
            ...options,
            model: options.model,
            autosaveModelField: true,
            formConfig: {
                useRowLayout: true,
                fields: [
                    {
                        type: 'tabset',
                        name: 'settings-tabs',
                        tabs: [
                            {
                                label: 'General',
                                fields: [
                                    {
                                        type: 'header',
                                        text: 'Organization Details',
                                        level: 5
                                    },
                                    {
                                        name: 'name',
                                        label: 'Organization Name',
                                        type: 'text',
                                        required: true,
                                        columns: 12
                                    },
                                    {
                                        name: 'metadata.timezone',
                                        label: 'Timezone',
                                        type: 'select',
                                        required: true,
                                        columns: { xs: 12, md: 6 },
                                        options: [
                                            { value: 'America/New_York', label: 'Eastern Time (ET)' },
                                            { value: 'America/Chicago', label: 'Central Time (CT)' },
                                            { value: 'America/Denver', label: 'Mountain Time (MT)' },
                                            { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
                                            { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
                                            { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
                                            { value: 'Europe/London', label: 'London (GMT/BST)' },
                                            { value: 'Europe/Paris', label: 'Paris (CET)' },
                                            { value: 'Europe/Berlin', label: 'Berlin (CET)' },
                                            { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
                                            { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
                                            { value: 'Asia/Dubai', label: 'Dubai (GST)' },
                                            { value: 'Australia/Sydney', label: 'Sydney (AEDT)' }
                                        ]
                                    }
                                ]
                            },
                            {
                                label: 'Billing',
                                fields: [
                                    {
                                        type: 'group',
                                        label: 'Billing Information',
                                        class: 'border rounded p-3 mb-3',
                                        columns: { xs: 12, lg: 6 },
                                        fields: [
                                            {
                                                name: 'metadata.billing.address.street',
                                                label: 'Street Address',
                                                type: 'text',
                                                columns: 12
                                            },
                                            {
                                                name: 'metadata.billing.address.city',
                                                label: 'City',
                                                type: 'text',
                                                columns: { xs: 12, md: 6 }
                                            },
                                            {
                                                name: 'metadata.billing.address.state',
                                                label: 'State/Province',
                                                type: 'text',
                                                columns: { xs: 12, md: 6 }
                                            },
                                            {
                                                name: 'metadata.billing.address.postal_code',
                                                label: 'Postal Code',
                                                type: 'text',
                                                columns: { xs: 12, md: 6 }
                                            },
                                            {
                                                name: 'metadata.billing.address.country',
                                                label: 'Country',
                                                type: 'select',
                                                columns: { xs: 12, md: 6 },
                                                options: [
                                                    { value: 'US', label: 'United States' },
                                                    { value: 'CA', label: 'Canada' },
                                                    { value: 'GB', label: 'United Kingdom' },
                                                    { value: 'AU', label: 'Australia' },
                                                    { value: 'DE', label: 'Germany' },
                                                    { value: 'FR', label: 'France' },
                                                    { value: 'JP', label: 'Japan' },
                                                    { value: 'CN', label: 'China' },
                                                    { value: 'IN', label: 'India' },
                                                    { value: 'MX', label: 'Mexico' }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        type: 'group',
                                        label: 'Billing Contact',
                                        class: 'border rounded p-3 mb-3',
                                        columns: { xs: 12, lg: 6 },
                                        fields: [
                                            {
                                                name: 'metadata.billing.contact.name',
                                                label: 'Contact Name',
                                                type: 'text',
                                                columns: 12
                                            },
                                            {
                                                name: 'metadata.billing.contact.email',
                                                label: 'Contact Email',
                                                type: 'email',
                                                columns: 12
                                            },
                                            {
                                                name: 'metadata.billing.contact.phone',
                                                label: 'Contact Phone',
                                                type: 'tel',
                                                columns: 12
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                label: 'Technical Contact',
                                fields: [
                                    {
                                        type: 'group',
                                        label: 'Technical Support Contact',
                                        class: 'border rounded p-3',
                                        columns: 12,
                                        fields: [
                                            {
                                                name: 'metadata.technical.contact.name',
                                                label: 'Contact Name',
                                                type: 'text',
                                                columns: { xs: 12, md: 6 }
                                            },
                                            {
                                                name: 'metadata.technical.contact.email',
                                                label: 'Contact Email',
                                                type: 'email',
                                                columns: { xs: 12, md: 6 }
                                            },
                                            {
                                                name: 'metadata.technical.contact.phone',
                                                label: 'Contact Phone',
                                                type: 'tel',
                                                columns: { xs: 12, md: 6 }
                                            },
                                            {
                                                name: 'metadata.technical.contact.title',
                                                label: 'Job Title',
                                                type: 'text',
                                                columns: { xs: 12, md: 6 }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                label: 'Notifications',
                                fields: [
                                    {
                                        type: 'header',
                                        text: 'Notification Settings',
                                        level: 5,
                                        className: 'mb-3'
                                    },
                                    {
                                        name: 'metadata.notify.no_mobile_sync',
                                        label: 'No Mobile Sync',
                                        help: 'This group will not send mobile push notifications (including lock credential syncing).',
                                        type: 'toggle',
                                        columns: { xs: 12, md: 6 }
                                    },
                                    {
                                        name: 'metadata.notify.ignore_left_open',
                                        label: 'Ignore Left Open',
                                        help: 'System will not send "Left Open" notifications to any user in this group.',
                                        type: 'toggle',
                                        columns: { xs: 12, md: 6 }
                                    },
                                    {
                                        name: 'metadata.notify.ignore_on_portal',
                                        label: 'Ignore Notifications in Portal',
                                        help: 'This group will not trigger portal notifications.',
                                        type: 'toggle',
                                        columns: { xs: 12, md: 6 }
                                    },
                                    {
                                        type: 'divider',
                                        class: 'my-3',
                                        columns: 12
                                    },
                                    {
                                        type: 'header',
                                        text: 'Left Open Timing Configuration',
                                        level: 5
                                    },
                                    {
                                        name: 'metadata.left_open_timings',
                                        label: 'Left Open Timings (comma separated minutes)',
                                        help: 'A list of times in minutes for when to fire left open notifications. The last timing will trigger global notifications. Example: 5,15,30,60,120',
                                        placeholder: '5,15,30,60',
                                        type: 'text',
                                        columns: 12
                                    }
                                ]
                            }
                        ]
                    }
                ],
                submitButton: false,
                resetButton: false
            }
        });
    }
}

export default class GroupSettingsPage extends Page {
    constructor(options = {}) {
        super({
            title: 'Group Settings',
            pageName: 'group/settings',
            route: 'group/settings',
            className: "container-sm m-3",
            template: '<div id="settings-form-container"></div>',
            ...options
        });

        this.formView = null;
    }

    async onInit() {
        await super.onInit();

        // Create form view once in onInit
        this.formView = new GroupSettingsFormView({
            containerId: 'settings-form-container'
        });

        this.addChild(this.formView);
    }

    async onBeforeRender() {
        await super.onBeforeRender();

        // Set/update the model before render
        const group = this.getApp().activeGroup;

        if (group && this.formView) {
            this.formView.setModel(group);
        }
    }

    async onGroupChange(group) {
        if (group && this.formView) {
            // Update the form with the new group model
            this.formView.setModel(group);
            await this.render();
        }
    }
}
